<template>
<VRow  class="mt-4 mx-2">
    <span class="caption error--text">
    {{ $t(getErrorMessage) }}
    </span>
</VRow>
</template>

<script lang="ts">
export default {
  name: 'SBookingRequestError',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps({
  bookingRequestErrorCode: {
    type: String,
    default: null,
  },
});

const getErrorMessage = computed(() => `errors.bookingForm.${props.bookingRequestErrorCode}`);
</script>
